'use strict';

var CalloutController = function CalloutController() {};
CalloutController.$inject = [];
module.exports = CalloutController;